<i18n>
{
  "de": {
    "nenaChooseOption": "Wähle eine der Optionen von NENA mitNdrin",
    "choose": "Auswählen",
    "perMonth": "pro Monat",
    "stockRemainingOneLine": "{stockRemaining} verfügba",
    "limitedStockAvailable": "Begrenzte Anzahl verfügbar",
    "oneTime": "einmalig",
    "or": "oder",
    "atLeast": "mindestens",
    "support": "Unterstütze",
    "minimumPledge": "mit einem Mindestbetrag von",
    "byOptingSubscription": "durch Wahl einer passenden Mitgliedschaft",
    "minimumPurchase": "mit einem Mindestbetrag von",
    "byOptingProduct": "durch einmaligen Kauf eines der angebotenen Produkte"

  },
  "en": {
    "nenaChooseOption": "Choose one of the options by NENA mitNdrin",
    "choose": "Choose",
    "perMonth": "per month",
    "stockRemainingOneLine": "{stockRemaining} available",
    "limitedStockAvailable": "Limited stock available",
    "oneTime": "one-time only",
    "or": "or",
    "atLeast": "at least",
    "support": "Support",
    "minimumPledge": "with your minimum pledge of",
    "byOptingSubscription": "by opting for one of the available subscription",
    "minimumPurchase": "with a minimum one-time purchase of",
    "byOptingProduct": "by opting for one of the available product"
  }
}
</i18n>

<template>
  <div>
    <div v-if="placeholderFeatureActive">
      <p>{{ $t('nenaChooseOption') }}</p>
      <div
        v-if="cheapestReward"
        class="content"
      >
        <ul class="purchasable-list">
          <li
            v-for="(reward, index) of postRewards"
            :key="index"
            :class="{ 'purchasable-selected': reward._id === selectedPurchasableId }"
          >
            <div class="purchasable-header">
              <div class="purchasable-header-text">
                <input
                  :id="`reward_${index}`"
                  v-model="selectedPurchasable"
                  class="is-checkradio is-danger"
                  type="radio"
                  name="purchasable"
                  :value="{ type: 'reward', item: reward }"
                >
                <button
                  v-if="reward._id === selectedPurchasableId"
                  class="button choose-button is-primary mr-20"
                  @click.prevent="$emit('selected', selectedPurchasable)"
                >
                  {{ $t('choose') }}
                </button>
                <label :for="`reward_${index}`">
                  <div
                    :class="{ selected: reward._id === selectedPurchasableId }"
                    class="title is-5 item-label"
                  >{{
                    reward.name }}</div>
                </label>
              </div>
              <div
                v-if="reward._id !== selectedPurchasableId"
                class="pricetag"
              >
                {{ centToEuro(reward.amount, true) }}
                <br>
                {{ $t('perMonth') }}
              </div>
            </div>

            <section
              v-show="reward._id === selectedPurchasableId"
              class="purchasable-information"
            >
              <div class="purchasable-price">
                {{ centToEuro(reward.amount, true) }} {{ $t('perMonth') }}
              </div>
              <div
                class="purchasable-description"
                v-html="reward.description"
              />
            </section>
          </li>
        </ul>
      </div>
      <div
        v-if="cheapestProduct"
        class="content"
      >
        <ul class="purchasable-list">
          <li
            v-for="(product, index) of postProducts"
            :key="index"
            :class="{ 'purchasable-selected': product._id === selectedPurchasableId }"
          >
            <div class="purchasable-header">
              <div class="purchasable-header-text">
                <input
                  :id="`product_${index}`"
                  v-model="selectedPurchasable"
                  class="is-checkradio is-danger"
                  type="radio"
                  name="purchasable"
                  :value="{ type: 'product', item: product }"
                >
                <button
                  v-if="product._id === selectedPurchasableId"
                  class="button is-primary mr-20 choose-button"
                  @click.prevent="selected(selectedPurchasable)"
                >
                  {{ $t('choose') }}
                </button>
                <label :for="`product_${index}`">
                  <div
                    :class="{ selected: product._id === selectedPurchasableId }"
                    class="title is-5 item-label"
                  >
                    {{ product.name }}
                  </div>
                  <div
                    v-if="product.stockRemaining && product._id !== selectedPurchasableId"
                    class="purchasable-stock-limit"
                  >
                    <span
                      v-if="product.showRemainingStock"
                      v-html="$t('stockRemainingOneLine', { stockRemaining: product.stockRemaining })"
                    />
                    <span
                      v-else
                      v-html="$t('limitedStockAvailable', { stockRemaining: product.stockRemaining })"
                    />
                  </div>
                </label>
              </div>
              <div
                v-if="product._id !== selectedPurchasableId"
                class="pricetag"
              >
                {{ centToEuro((product.minAmount || product.amount), true) }}
                <br>
                {{ $t('oneTime') }}
              </div>
            </div>

            <section
              v-show="product._id === selectedPurchasableId"
              class="purchasable-information"
            >
              <div
                v-if="product.stockRemaining"
                class="purchasable-stock-limit selected"
              >
                <span
                  v-if="product.showRemainingStock"
                  v-html="$t('singleRewards.stockRemainingOneLine', { stockRemaining: product.stockRemaining })"
                />
                <span
                  v-else
                  v-html="$t('singleRewards.limitedStockAvailable', { stockRemaining: product.stockRemaining })"
                />
              </div>
              <div class="purchasable-price">
                <span v-if="product.minAmount">{{ $t('atLeast') }}</span>
                {{ centToEuro((product.minAmount || product.amount), true) }} {{ $t('oneTime') }}
              </div>
              <div
                class="purchasable-description"
                v-html="product.description"
              />
            </section>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div
        v-if="cheapestReward"
        class="content"
      >
        <p>
          {{ $t('support') }} {{ artist.nickname }} {{ $t('minimumPledge') }} {{ centToEuro(cheapestReward.amount,
                                                                                            true) }}
          {{ $t('perMonth') }} {{ $t('byOptingSubscription') }}:
        </p>
        <ul class="purchasable-list">
          <li
            v-for="(reward, index) of postRewards"
            :key="index"
            :class="{ 'purchasable-selected': reward._id === selectedPurchasableId }"
          >
            <div class="purchasable-header">
              <div class="purchasable-header-text">
                <input
                  :id="`reward_${index}`"
                  v-model="selectedPurchasable"
                  class="is-checkradio is-danger"
                  type="radio"
                  name="purchasable"
                  :value="{ type: 'reward', item: reward }"
                >
                <button
                  v-if="reward._id === selectedPurchasableId"
                  class="button choose-button is-primary mr-20"
                  @click.prevent="$emit('selected', selectedPurchasable)"
                >
                  {{ $t('choose') }}
                </button>
                <label :for="`reward_${index}`">
                  <div
                    :class="{ selected: reward._id === selectedPurchasableId }"
                    class="title is-5 item-label"
                  >{{
                    reward.name }}</div>
                </label>
              </div>
              <div
                v-if="reward._id !== selectedPurchasableId"
                class="pricetag"
              >
                {{ centToEuro(reward.amount, true) }}
                <br>
                {{ $t('perMonth') }}
              </div>
            </div>

            <section
              v-show="reward._id === selectedPurchasableId"
              class="purchasable-information"
            >
              <div class="purchasable-price">
                {{ centToEuro(reward.amount, true) }} {{ $t('perMonth') }}
              </div>
              <div
                class="purchasable-description"
                v-html="reward.description"
              />
            </section>
          </li>
        </ul>
      </div>
      <div
        v-if="cheapestProduct"
        class="content"
      >
        <p>
          <span v-if="cheapestReward">{{ $t('or') }}</span>
          <span v-else>{{ $t('support') }} {{ artist.nickname }}</span>
          {{ $t('minimumPurchase') }} {{ centToEuro(cheapestProduct.amount, true) }} {{ $t('byOptingProduct') }}:
        </p>
        <ul class="purchasable-list">
          <li
            v-for="(product, index) of postProducts"
            :key="index"
            :class="{ 'purchasable-selected': product._id === selectedPurchasableId }"
          >
            <div class="purchasable-header">
              <div class="purchasable-header-text">
                <input
                  :id="`product_${index}`"
                  v-model="selectedPurchasable"
                  class="is-checkradio is-danger"
                  type="radio"
                  name="purchasable"
                  :value="{ type: 'product', item: product }"
                >
                <button
                  v-if="product._id === selectedPurchasableId"
                  class="button is-primary mr-20 choose-button"
                  @click.prevent="selected(selectedPurchasable)"
                >
                  {{ $t('choose') }}
                </button>
                <label :for="`product_${index}`">
                  <div
                    :class="{ selected: product._id === selectedPurchasableId }"
                    class="title is-5 item-label"
                  >
                    {{ product.name }}
                  </div>
                  <div
                    v-if="product.stockRemaining && product._id !== selectedPurchasableId"
                    class="purchasable-stock-limit"
                  >
                    <span
                      v-if="product.showRemainingStock"
                      v-html="$t('singleRewards.stockRemainingOneLine', { stockRemaining: product.stockRemaining })"
                    />
                    <span
                      v-else
                      v-html="$t('singleRewards.limitedStockAvailable', { stockRemaining: product.stockRemaining })"
                    />
                  </div>
                </label>
              </div>
              <div
                v-if="product._id !== selectedPurchasableId"
                class="pricetag"
              >
                {{ centToEuro((product.minAmount || product.amount), true) }}
                <br>
                {{ $t('oneTime') }}
              </div>
            </div>

            <section
              v-show="product._id === selectedPurchasableId"
              class="purchasable-information"
            >
              <div
                v-if="product.stockRemaining"
                class="purchasable-stock-limit selected"
              >
                <span
                  v-if="product.showRemainingStock"
                  v-html="$t('singleRewards.stockRemainingOneLine', { stockRemaining: product.stockRemaining })"
                />
                <span
                  v-else
                  v-html="$t('singleRewards.limitedStockAvailable', { stockRemaining: product.stockRemaining })"
                />
              </div>
              <div class="purchasable-price">
                <span v-if="product.minAmount">{{ $t('atLeast') }}</span>
                {{ centToEuro((product.minAmount || product.amount), true) }} {{ $t('oneTime') }}
              </div>
              <div
                class="purchasable-description"
                v-html="product.description"
              />
            </section>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      selectedPurchasable: null
    }
  },
  props: ['post', 'item', 'placeholderFeatureActive'],

  computed: {
    ...mapState(['artist']),
    postRewards() {
      return this.artist.rewards
        .filter(r => this.post.limitToReward.includes(r._id.toString()))
        .sort((a, b) => {
          if (a.amount > b.amount) {
            return 1
          } else if (a.amount < b.amount) {
            return -1
          }
          return 0
        })
    },
    availableProducts() {
      return this.artist.products.filter(p => {
        return p.stockRemaining === null || p.stockRemaining > 0
      })
    },
    postProducts() {
      return this.availableProducts
        .filter(p => this.post.limitToProduct.includes(p._id.toString()))
        .sort((a, b) => {
          if ((a.minAmount || a.amount) > (b.minAmount || b.amount)) {
            return 1
          } else if ((a.minAmount || a.amount) < (b.minAmount || b.amount)) {
            return -1
          }
          return 0
        })
    },
    cheapestProduct() {
      if (!this.postProducts.length) return null
      const cheapestProduct = this.postProducts[0]
      return {
        _id: cheapestProduct._id,
        amount: cheapestProduct.minAmount || cheapestProduct.amount
      }
    },
    cheapestReward() {
      if (!this.postRewards.length) return null
      const cheapestReward = this.postRewards[0]
      return cheapestReward
    },
    selectedPurchasableId() {
      return this.selectedPurchasable ? this.selectedPurchasable.item._id : null
    }
  },

  methods: {
    preSelectItem(item) {
      if (['product', 'single-reward'].includes(item.itemType)) {
        const result = this.postProducts.filter(p => p._id === item.itemId)
        if (result.length) {
          this.selectedPurchasable = {
            item: result[0],
            type: 'product'
          }
          this.$emit('selected', this.selectedPurchasable)
        }
      } else if (item.itemType === 'reward') {
        const result = this.postRewards.filter(r => r._id === item.itemId)
        if (result.length) {
          this.selectedPurchasable = {
            item: result[0],
            type: 'reward'
          }
          this.$emit('selected', this.selectedPurchasable)
        }
      }
    },
    selected(item) {
      if (item.itemType === 'reward') {
        return this.$emit('selected', this.selectedPurchasable)
      }
      const url = this.checkoutUrl(item.item._id)
      window.location.assign(url)
    }
  },

  mounted() {
    if (
      this.item &&
      this.item.itemId &&
      ['reward', 'single-reward', 'product'].includes(this.item.itemType)
    ) {
      this.preSelectItem(this.item)
    }
  }
}
</script>
<style lang="scss">
@import 'assets/sass/_variables';

.wizard-tab-container {
  .content {
    margin-bottom: 10px !important;
  }
}

.purchasable-list {
  padding: 0px;
  margin-left: 0px !important;
  display: block;
  list-style: none;
  order: 0;

  li {
    display: block;
    padding: 10px 0px;

    .purchasable-header {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .choose-button {
        margin-left: 10px;
      }

      label {
        &::before {
          border-width: 2px;
          border-radius: 20%;
          margin-top: -3px;
        }

        .item-label {
          padding-left: 40px;
          margin-top: -26px;
          padding-right: 20px;

          &.selected {
            padding-left: 150px;
            margin-top: -30px;
            text-align: center;
          }
        }
      }

      .pricetag {
        display: inline-block;
        font-size: 0.8rem;
        text-align: center;
        min-width: 85px;
      }
    }

    .purchasable-stock-limit {
      width: 100%;
      margin-left: 42px;

      &.selected {
        margin-left: 0px;
        margin-top: 0px;
        margin-bottom: 4px;
      }

      span {
        display: block;
        color: #fb3e52;
        font-size: .8em;
        line-height: 1.2em;
        font-weight: bold;
        text-align: left;
      }
    }

    .purchasable-information {
      margin-top: 15px;
      padding: 10px;
      background: $light;

      .purchasable-price {
        font-size: 0.9rem;
      }

      .purchasable-description {
        margin-top: 5px;
      }
    }

    &.purchasable-selected {
      border: 2px solid $medium;
      border-radius: 5px;
    }
  }
}
</style>
